// NOTE: Currently this won't work if there is more than 1 custom file input on the page.
$(function() {
    $('.custom-file-input').on('change',function(){
        var fileName = $(this).val();
        var cleanFileName = fileName.replace('C:\\fakepath\\', '');
        $(this).next('.custom-file-label').html(cleanFileName);
    })
});